import { prepararImagenWebp } from './prepararImagenWebp.js';

const MAX_LADO_PX = 512;
const MAX_ENTRADA_BYTES = 8 * 1024 * 1024;
const MAX_SALIDA_BYTES = 500 * 1024;

/**
 * Reduce y comprime una imagen para foto de perfil (avatar).
 */
export async function prepararFotoPerfil(file) {
  const base = (file?.name || 'perfil').replace(/\.[^.]+$/, '') + '_perfil';
  return prepararImagenWebp({
    file,
    maxInputBytes: MAX_ENTRADA_BYTES,
    maxSidePx: MAX_LADO_PX,
    maxOutputBytes: MAX_SALIDA_BYTES,
    outputNameBase: base,
    emptyFileMessage: 'Archivo de foto vacío.',
    tooLargeMessage: 'La foto supera 8 MB. Elegí una imagen más liviana.',
    invalidTypeMessage: 'Tenés que elegir una imagen (JPG, PNG o similar).',
  });
}
